import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from "react-svg-inline"

// Style import
import './RandomIcons.css';

const SpreadIcons = ({
                        iconSVG = '',
                        customClass = '',
                        icons = [],
                        isLoopMove
}) => {

    const generateIcons = () => {
        return icons.map((icon, i) => {
            return (
                <SVGInline
                    key={`random-icon-${i}}`}
                    className={`random-icon spread-icon ${isLoopMove ? 'idle-move' : ''}`}
                    svg={iconSVG}
                    component={'i'}
                    width={icon.width}
                    style={{
                        top: icon.top,
                        left: icon.left,
                        right: icon.right,
                        bottom: icon.bottom,
                        opacity: icon.opacity
                    }}
                />
            )
        })
    };

    return (
        <div className={`random-icons-wrapper ${customClass}`}>
            {generateIcons()}
        </div>
    )
};

SpreadIcons.propTypes = {
    customClass: PropTypes.string,
    iconSVG: PropTypes.string,
    icons: PropTypes.array,
    isLoopMove: PropTypes.bool
};

export default SpreadIcons;




// WEBPACK FOOTER //
// ./src/Components/Elements/Decorations/SpreadIcons.js